<template>
    <div class="mainbox" style="border-radius:5px 5px 0 0">
        <div
            data-aos="fade-left"
            data-aos-delay="1400"
            data-aos-easing="ease-in-out"
            data-aos-anchor-placement="top-bottom"
            data-aos-offset="120"
        >
            <div class="contact">
                <dl>
                    <dt><i class="iconfont icon-ziyuan"></i></dt>
                    <dd>
                        <p>{{lang[local].part2_txt1}} <b><a style="color:#E95B57" href="https://explorer.bvcadt.com" target="_blank">explorer.bvcadt.com</a> </b></p>
                        
                    </dd>
                </dl>
                <dl>
                    <dt><i class="iconfont icon-youxiang"></i></dt>
                    <dd>
                        <p>{{lang[local].part2_txt2}} <b><a style="color:#E95B57" href="mailto:service@bvcadt.com">service@bvcadt.com</a></b></p>
                    </dd>
                </dl>
                <dl>
                    <dt><i class="iconfont icon-kaifazhe"></i></dt>
                    <dd>
                        <p>{{lang[local].part2_txt11}} <b><a style="color:#E95B57" href="https://developers.bvcadt.com/" target="_blank">developers.bvcadt.com</a></b></p>
                    </dd>
                </dl>
                <dl>
                    <dt><i class="iconfont icon-git"></i></dt>
                    <dd>
                        <p>{{lang[local].part2_txt22}} </p>
                        <p><b><a style="color:#E95B57" href="https://github.com/bvcadt" target="_blank">github.com/bvcadt</a></b></p>
                    </dd>
                </dl>
            </div>
            <h2 class="tit">{{lang[local].part2_txt3}}</h2>
            <p class="subtit">{{lang[local].part2_txt4}}</p>
            <div class="icon">
                <span><i class="iconfont icon-jiaoyi"></i></span>
                <span><i class="iconfont icon-icon-"></i> </span>
                <span><i class="iconfont icon-jinbi"></i> </span>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex"
export default {
    data () {
        return{
            
        }
    },
    computed:
        mapState(['lang','local','skin'])
    ,
    mounted () {

    },
    methods:{

    }
    // render (h) {
    //     return (
    //     )
    // }
}
</script>

<style lang="less" scoped>
    .icon{
        text-align: center;
        span{
            background: #E95B57;
            border-radius:50%;
            width: 60px;
            height:60px;
            line-height: 60px;
            margin:70px 10px;
            display: inline-block;
            i{font-size:40px;color:#fff;}
        }
    }
    .contact{
        padding:0 15px;
        margin-top:30px;
        overflow: hidden;
        dl{
            width: 46%;
            margin: 2%;
            padding:20px 15px;
            background: #EFEFEF;
            border-top:2px solid #FF2317;
            float: left;
            dt{
                color:#E95B57;
                i{font-size:40px;}
                display: inline-block;
                width: 100px;
                text-align: center;
                vertical-align: top;
            }
            dd{
                display: inline-block;
                color: #8f8f8f;
                line-height: 26px;
                font-size:15px;
                width: 70%;
            }
        }
    }
</style>

